
export default {
    oidc: {
        clientId: '0oajipz26HkplKisK4x6',
        issuer: 'https://dev-513487.okta.com/oauth2/default',
        redirectUri: 'http://localhost:8080/implicit/callback',
        scopes: ['openid', 'profile', 'email'],
        pkce: true,
        disableHttpsCheck: false,
    },
}